export default "__VITE_ASSET__db3704c7__"